import { CheckInsPerPetDetailRoutingModule } from './check-ins-per-pet-detail-routing.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CheckInsPerPetDetailRoutingModule,
  ]
})
export class CheckInsPerPetDetailModule { }
